import { setDoc, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "/Users/michaeltucker/Documents/coding-projects/client/src/firebase.js";
import { FIREBASE_COLLECTIONS } from "../config/firebaseCollections";

const Scheduling = {

    weekDayLetterOptions: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N"],
    daysOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    daysOfWeekWithWeekends: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    dayMapping: {
        "Monday": "M",
        "Tuesday": "T",
        "Wednesday": "W",
        "Thursday": "Th",
        "Friday": "F",
    },
    dayMappingWithWeekends: {
        "Monday": "M",
        "Tuesday": "T",
        "Wednesday": "W",
        "Thursday": "Th",
        "Friday": "F",
        "Saturday": "S",
        "Sunday": "Su",
    },
    dayOrder: ["M", "T", "W", "Th", "F", "S", "Su"],
    weeksOrder: (numberOfWeeks) => Scheduling.weekDayLetterOptions.slice(0, numberOfWeeks),
    days: ['Sun', 'Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat'],
    daysLong: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Octo', 'Nov', 'Dec'],
    monthsLong: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    suffix: ['', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'st'],

    blankSchedule: {
        "A": {
            "Monday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Tuesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Wednesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Thursday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Friday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Saturday": {active: false, startTime: '00:00', endTime: '00:00'},
            "Sunday": {active: false, startTime: '00:00', endTime: '00:00'},
        },
        "B": {
            "Monday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Tuesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Wednesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Thursday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Friday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Saturday": {active: false, startTime: '00:00', endTime: '00:00'},
            "Sunday": {active: false, startTime: '00:00', endTime: '00:00'},
        },
        "C": {
            "Monday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Tuesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Wednesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Thursday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Friday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Saturday": {active: false, startTime: '00:00', endTime: '00:00'},
            "Sunday": {active: false, startTime: '00:00', endTime: '00:00'},
        },
        "D": {
            "Monday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Tuesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Wednesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Thursday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Friday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Saturday": {active: false, startTime: '00:00', endTime: '00:00'},
            "Sunday": {active: false, startTime: '00:00', endTime: '00:00'},
        },
        "E": {
            "Monday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Tuesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Wednesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Thursday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Friday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Saturday": {active: false, startTime: '00:00', endTime: '00:00'},
            "Sunday": {active: false, startTime: '00:00', endTime: '00:00'},
        },
        "F": {
            "Monday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Tuesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Wednesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Thursday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Friday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Saturday": {active: false, startTime: '00:00', endTime: '00:00'},
            "Sunday": {active: false, startTime: '00:00', endTime: '00:00'},
        },
        "G": {
            "Monday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Tuesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Wednesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Thursday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Friday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Saturday": {active: false, startTime: '00:00', endTime: '00:00'},
            "Sunday": {active: false, startTime: '00:00', endTime: '00:00'},
        },
        "H": {
            "Monday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Tuesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Wednesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Thursday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Friday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Saturday": {active: false, startTime: '00:00', endTime: '00:00'},
            "Sunday": {active: false, startTime: '00:00', endTime: '00:00'},
        },
        "I": {
            "Monday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Tuesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Wednesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Thursday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Friday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Saturday": {active: false, startTime: '00:00', endTime: '00:00'},
            "Sunday": {active: false, startTime: '00:00', endTime: '00:00'},
        },
        "J": {
            "Monday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Tuesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Wednesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Thursday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Friday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Saturday": {active: false, startTime: '00:00', endTime: '00:00'},
            "Sunday": {active: false, startTime: '00:00', endTime: '00:00'},
        },
        "K": {
            "Monday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Tuesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Wednesday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Thursday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Friday": {active: true, startTime: '00:00', endTime: '00:00'},
            "Saturday": {active: false, startTime: '00:00', endTime: '00:00'},
            "Sunday": {active: false, startTime: '00:00', endTime: '00:00'},
        },
    },

    addWeeksToSchedule: async (setData, user, classId) => {

        // ✅ Check if all required parameters are provided before executing
        if (!setData || !user?.uid || !classId) {
            // console.error("❌ Missing required parameters: setData, user, or classId.");
            return;
        }

        try {
            const classRef = doc(db, FIREBASE_COLLECTIONS.USERS, user.uid, FIREBASE_COLLECTIONS.CLASSES, classId);
            const classSnap = await getDoc(classRef);
    
            if (!classSnap.exists()) {
                console.error("Class not found in Firestore");
                return;
            }
    
            const classData = classSnap.data();
            const currentSchedule = classData?.schedule || {}; // Ensure schedule exists
            const newWeeks = {};
    
            // ✅ Ensure Scheduling.weekDayLetterOptions exists before using it
            if (!Scheduling?.weekDayLetterOptions || !Array.isArray(Scheduling.weekDayLetterOptions)) {
                console.error("Scheduling.weekDayLetterOptions is missing or not an array.");
                return;
            }
    
            // Generate any missing weeks dynamically
            for (const week of Scheduling.weekDayLetterOptions) {
                if (!(week in currentSchedule)) {
                    newWeeks[week] = {
                        "Monday": { active: true, startTime: "00:00", endTime: "00:00" },
                        "Tuesday": { active: true, startTime: "00:00", endTime: "00:00" },
                        "Wednesday": { active: true, startTime: "00:00", endTime: "00:00" },
                        "Thursday": { active: true, startTime: "00:00", endTime: "00:00" },
                        "Friday": { active: true, startTime: "00:00", endTime: "00:00" },
                        "Saturday": { active: false, startTime: "00:00", endTime: "00:00" },
                        "Sunday": { active: false, startTime: "00:00", endTime: "00:00" }
                    };
                }
            }
    
            // ✅ Ensure Firestore is only updated if there are changes
            if (Object.keys(newWeeks).length > 0) {
                await updateDoc(classRef, {
                    schedule: { ...currentSchedule, ...newWeeks },
                });
    
                // ✅ Ensure UI state updates only when necessary
                setData((prevData) => ({
                    ...prevData,
                    schedule: { ...prevData.schedule, ...newWeeks },
                }));
    
                console.log("Missing weeks added successfully.");
            } else {
                console.log("All weeks already present. No update needed.");
            }
        } catch (error) {
            console.error("Error updating schedule: ", error);
        }
    },

    getWeeksWithActiveMonday: (schedule, user) => {
        const numberOfWeeks = user.settings.numberOfWeeks ?? 1; // Default to 1 if undefined or null
        const weeksToCheck = Scheduling.weekDayLetterOptions.slice(0, numberOfWeeks); // Limit to active weeks
      
        return weeksToCheck
          .filter(week => schedule[week]?.Monday?.active)
          .join(", ");
    },

    convertTo12HourFormat: (time24) => {
        const [hours, minutes, secondsRaw] = time24.split(':').map(Number);
        const period = hours >= 12 ? 'PM' : 'AM';
        const hours12 = hours % 12 || 12;
        const seconds = secondsRaw || 0;
      
        const baseTime = `${hours12}:${String(minutes).padStart(2, '0')}`;
        const timeWithSeconds = seconds !== 0
          ? `${baseTime}:${String(seconds).padStart(2, '0')} ${period}`
          : `${baseTime} ${period}`;
      
        return timeWithSeconds;
    },   

    listActiveStartTimes: (data, user) => {
        if (!data || typeof data !== 'object') return '';
      
        const uniqueTimes = new Set();
        const excludedDays =
          user.settings.multiWeek && user.settings.cycleType === "day"
            ? new Set(["Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"])
            : new Set(["Saturday", "Sunday"]);

        const weeksToCheck = user.settings.multiWeek
            ? Scheduling.weekDayLetterOptions.slice(0, user.settings.numberOfWeeks ?? 1)
            : Scheduling.weekDayLetterOptions.slice(0, 1);

        // console.log("weeksToCheck => ", weeksToCheck)
      
        for (const week of weeksToCheck) {
          if (!data[week]) continue;
      
          const days = data[week];
      
          for (const dayKey in days) {
            if (!excludedDays.has(dayKey)) {
                // console.log("dayKey => ", dayKey)
              const day = days[dayKey];
            //   console.log("day.startTime => ", day.startTime)

              if (day?.active) {
                uniqueTimes.add(Scheduling.convertTo12HourFormat(day.startTime));
              }
            }
          }
        }
      
        return Array.from(uniqueTimes).join(', ');
    },

    listActiveEndTimes: (data, user) => {
        if (!data || typeof data !== 'object') return '';

        const uniqueTimes = new Set();
        const excludedDays =
          user.settings.multiWeek && user.settings.cycleType === "day"
            ? new Set(["Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"])
            : new Set(["Saturday", "Sunday"]);

        const weeksToCheck = user.settings.multiWeek
            ? Scheduling.weekDayLetterOptions.slice(0, user.settings.numberOfWeeks ?? 1)
            : Scheduling.weekDayLetterOptions.slice(0, 1);

        for (const week of weeksToCheck) {
          if (!data[week]) continue;

          const days = data[week];

          for (const dayKey in days) {
            if (!excludedDays.has(dayKey)) {
              const day = days[dayKey];
              if (day?.active && day?.endTime) {
                uniqueTimes.add(Scheduling.convertTo12HourFormat(day.endTime));
              }
            }
          }
        }

        return Array.from(uniqueTimes).join(', ');
    },

    normalizeDateInput: (input) => {
        if (input instanceof Date) {
            return new Date(input.getFullYear(), input.getMonth(), input.getDate());
        }

        if (typeof input === "string") {
            const [year, month, day] = input.split("-").map(Number);
            if ([year, month, day].every(Number.isFinite)) {
                return new Date(year, month - 1, day);
            }
        }

        if (input && typeof input === "object" && Number.isFinite(input.year) && Number.isFinite(input.month) && Number.isFinite(input.day)) {
            return new Date(input.year, input.month, input.day);
        }

        const today = new Date();
        return new Date(today.getFullYear(), today.getMonth(), today.getDate());
    },

    getDayNameForDate: (input) => {
        const date = Scheduling.normalizeDateInput(input);
        return Scheduling.daysLong[date.getDay()];
    },

    getLegacyResolvedScheduleSlot: (settings = {}, activeDate = new Date()) => {
        const date = Scheduling.normalizeDateInput(activeDate);
        const actualDayName = Scheduling.getDayNameForDate(date);

        if (!settings?.multiWeek) {
            return {
                date,
                scheduleKey: "A",
                dayName: actualDayName,
            };
        }

        const total = Math.max(1, Number(settings?.numberOfWeeks) || 1);
        const anchorDate = Scheduling.normalizeDateInput(
            settings?.lastCheckedDateForDayWeeklyCycleChange || new Date()
        );
        const anchorLetter = String(settings?.currentWeek || "A").toUpperCase();
        const anchorIndex = ((anchorLetter.charCodeAt(0) - 65) % total + total) % total;

        const getStartOfIsoWeek = (input) => {
            const normalizedDate = Scheduling.normalizeDateInput(input);
            const day = normalizedDate.getDay();
            const diff = day === 0 ? -6 : 1 - day;
            normalizedDate.setDate(normalizedDate.getDate() + diff);
            return normalizedDate;
        };

        const countWeekdayOffset = (fromInput, toInput) => {
            const from = Scheduling.normalizeDateInput(fromInput);
            const to = Scheduling.normalizeDateInput(toInput);
            if (from.getTime() === to.getTime()) return 0;

            const step = from < to ? 1 : -1;
            const pointer = new Date(from);
            let offset = 0;

            while (pointer.getTime() !== to.getTime()) {
                pointer.setDate(pointer.getDate() + step);
                const day = pointer.getDay();
                if (day !== 0 && day !== 6) {
                    offset += step;
                }
            }

            return offset;
        };

        const countIsoWeekOffset = (fromInput, toInput) => {
            const from = getStartOfIsoWeek(fromInput);
            const to = getStartOfIsoWeek(toInput);
            const msPerWeek = 7 * 24 * 60 * 60 * 1000;
            return Math.round((to.getTime() - from.getTime()) / msPerWeek);
        };

        const offset = settings?.cycleType === "week"
            ? countIsoWeekOffset(anchorDate, date)
            : countWeekdayOffset(anchorDate, date);

        const scheduleIndex = ((anchorIndex + offset) % total + total) % total;
        const scheduleKey = String.fromCharCode(65 + scheduleIndex);

        return {
            date,
            scheduleKey,
            dayName: settings?.cycleType === "day" ? "Monday" : actualDayName,
        };
    },

    getLegacyScheduleEntry: (schedule, settings = {}, activeDate = new Date()) => {
        const resolvedSlot = Scheduling.getLegacyResolvedScheduleSlot(settings, activeDate);
        return {
            ...resolvedSlot,
            entry: schedule?.[resolvedSlot.scheduleKey]?.[resolvedSlot.dayName] || null,
        };
    }
}

export default Scheduling;